<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold my-5">{{ item.name }}</div>
            <a-table :dataSource="Object.values(item.bank_accounts)" :columns="columns" :pagination="false"  class="tbl-receivable">
              <template slot="description" slot-scope="text,record">
                {{ limitTextTask(record.description) }}
              </template>
              <template slot="date" slot-scope="text,record">
                {{ setDateFormat(record.last_activity) }}
              </template>
              <template slot="footer">
                <template v-if="Object.values(item.bank_accounts).length">
                  <!--                    <div class="flex justify-between">-->
                  <!--                      <div class="font-bold">Total:</div>-->
                  <!--                      <div>{{ 'RM' + sumCol(account.transactions,'amount') }}</div>-->
                  <!--                      <div>{{ 'RM' + sumCol(account.transactions,'balance') }}</div>-->
                  <!--                    </div>-->
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <a-form-item>
          <a-checkbox>Show clients with zero balance</a-checkbox>
        </a-form-item>
        <a-form-item>
          <a-checkbox>Include balances not associated with a client</a-checkbox>
        </a-form-item>
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Client/Matter">
              <a-radio-group v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleMatterClient">
                <a-radio :style="radioStyle" :value="1">
                  All Clients
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Client
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="checked_matter_client === 2"
              :required="false"
              url="/contact/query/"
              :options="optionSearchContact"
              class="self-end mt-8 md:mt-0 w-full"
              :is_include_matter="false"
              @selectSearch="handleSearch"
            />
          </div>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
          <DateRangeComponent :dateForm="form" class="mt-5"/>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','ClientReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";


const columns = [
  {
    title: 'Bank account',
    dataIndex: 'name',
    key: '1',
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    key: '2',

  },
  {
    title: 'LastActivity',
    dataIndex: 'last_activity',
    key: '3',
    scopedSlots: { customRender: 'date' },
  },
];

export default {
  name: "ComponentTrustListing",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    DateRangeComponent,
    ExportPdf,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      user_value: null,
      checked_matter_client: null,
      title:'Trust Listing',
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  methods:{
    handleChangeUser({target:{value}}){
      this.user_value = value
    },
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query     = []
            if (values.contact) query.push({ field:'id', condition: '=', value: values.contact, operation: 'and' })
            if (values.practice_area) query.push({ field:'client_matters__practice_area', condition: '=', value: values.practice_area, operation: 'and' })
            if (values.from_date && values.to_date) query.push({ field:'created_at', condition: '>=', value: values.from_date },{ field:'created_at', condition: '<=', value: values.to_date })
            const {data}    = await axios.post('contact/report/account-listing',{ query: query.length ? query : undefined  })
            this.visibleRes = true
            this.result     = Object.values(data)
          }catch (e) {
            this.visibleRes = false
            this.$message.error('Error generating report')
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    }
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
